<template>
  <p class="ren-decoration-cp ren-decoration-cp-content-body" :style="textStyle">{{ plainText }}</p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { numberValue, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const plainText = computed(() =>
  stringValue(data.value.html ?? data.value.content ?? data.value.body, '暂无正文')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
)
const textStyle = computed(() => {
  const fontSize = numberValue(props.component.props?.fontSize, 0)
  const lineHeight = numberValue(props.component.props?.lineHeight, 0)
  const color = stringValue(props.component.style?.textColor)
  return {
    color: color || undefined,
    fontSize: fontSize > 0 ? `${fontSize}px` : undefined,
    lineHeight: lineHeight > 0 ? String(lineHeight) : undefined
  }
})
</script>

<style scoped>
.ren-decoration-cp-content-body {
  margin: 0;
  overflow-wrap: anywhere;
  line-height: 1.7;
  color: var(--ren-theme-text);
  font-size: 14px;
}
</style>
